<template>
  <SectionTemplate
    class="customize-avatar-section"
    title="个性化编辑形象 轻松打造专属数字人形象"
    sub-title="个性化编辑人物"
    :desc="`从五官到发型，从妆容到服饰，有言支持全方位个性化调整，让每个数字人都独一无二，\n完美贴合你的身份角色、内容场景与品牌形象`"
  >
    <div class="avatar-detail-container">
      <VideoTabs v-for="item in items" :tabs="item.tabs" :muted="item.muted" :title="item.title" />
    </div>
    <StartBtn class="customize-avatar-btn" type="small" />
  </SectionTemplate>
</template>

<script setup lang="ts">
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import VideoTabs from '~/design/widgets/multi-tabs-video/index.vue';
import { getFeUrl } from '~/utils/url';
import StartBtn from '../../components/start-btn.vue';

const items = [
  {
    title: '个性化捏脸',
    muted: true,
    tabs: [
      {
        id: 'face',
        title: '脸型',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/face/1.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/face/1.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'eye',
        title: '眼部',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/face/2.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/face/2.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'nose',
        title: '鼻子',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/face/3.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/face/3.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'mouth',
        title: '嘴巴',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/face/4.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/face/4.png?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
  {
    title: '一键切换妆容',
    tabs: [
      {
        id: 'pro',
        title: '通勤职业妆',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/makeup/1.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/makeup/1.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'campus',
        title: '青春校园妆',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/makeup/2.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/makeup/2.png?x-oss-process=image/format,webp',
        ),
        muted: false,
      },
      {
        id: 'stylish',
        title: '时尚雪花妆',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/makeup/3.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/makeup/3.png?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
  {
    title: '一键切换发型和发色',
    tabs: [
      {
        id: 'cowboy',
        title: '牛仔蓝短发',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/hair/1.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/hair/1.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'sexy',
        title: '随性感背头',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/hair/2.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/hair/2.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'korean',
        title: '韩系蓬松短发',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/hair/3.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/hair/3.png?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
  {
    title: '一键切换服装',
    tabs: [
      {
        id: 'pro',
        title: '职场套装',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/dress/1.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/dress/1.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'china',
        title: '国风中山装',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/dress/2.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/dress/2.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'casual',
        title: '简约休闲装',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/dress/3.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/dress/3.png?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
  {
    title: '一键切换配饰',
    tabs: [
      {
        id: 'earrings',
        title: '耳坠',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/accessories/1.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/accessories/1.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'necklace',
        title: '项链',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/accessories/2.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/accessories/2.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'glasses',
        title: '眼镜',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/accessories/3.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/accessories/3.png?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
  {
    title: '自定义服装Logo',
    tabs: [
      {
        id: 'chest',
        title: '胸口LOGO',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/logo/1.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/logo/1.png?x-oss-process=image/format,webp',
        ),
      },
      {
        id: 'arm',
        title: '手臂LOGO',
        videoUrl: getFeUrl('/youyan-platform/character-intro/customization/logo/2.webm'),
        image: getFeUrl(
          '/youyan-platform/character-intro/customization/logo/2.png?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
];
</script>

<style lang="scss" scoped src="./pc.scss"></style>
<style lang="scss" scoped src="./mobile.scss"></style>
